import { FiAlertCircle } from 'react-icons/fi'

import moment from 'moment'

import Tooltip from '~/components/Tooltip'
import i18n from '~/i18n'

import { ROAS_CUTOFF_DATE } from '../../constants'
import { useClickMetricsCutoffAlert } from '../../hooks/useClickMetricsCutoffAlert'

interface ConversionsCutoffAlertIconProps {
  /** Considera também o período de comparação (só existe nos cards). */
  checkCompare?: boolean
}

/**
 * Ícone de alerta específico de "Conversões": calcula por conta própria se o
 * período selecionado tem data anterior ao cutoff de atribuição de ROAS e,
 * se sim, avisa que o total pode incluir conversões atribuídas apenas a
 * clique (período legado). Não renderiza nada fora dessa condição.
 */
export function ConversionsCutoffAlertIcon({
  checkCompare = false
}: ConversionsCutoffAlertIconProps = {}): JSX.Element | null {
  const hasCutoffOverlap = useClickMetricsCutoffAlert({ checkCompare })

  if (!hasCutoffOverlap) return null

  // Chave dinâmica: o `t` tipado não aceita template string.
  const translate = i18n.t as unknown as (
    key: string,
    options?: Record<string, string>
  ) => string
  const date = moment(ROAS_CUTOFF_DATE, 'DD/MM/YYYY').format(
    translate('c:patterns.date')
  )
  const text = translate('rm:alerts.conversionsCutoff', { date })

  return (
    <span
      onClick={event => event.stopPropagation()}
      onKeyDown={event => event.stopPropagation()}
    >
      <Tooltip noMargin text={text}>
        <span
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            color: '#d99a2b',
            height: '100%'
          }}
        >
          <FiAlertCircle size={13} />
        </span>
      </Tooltip>
    </span>
  )
}
